import { render, staticRenderFns } from "./ChangePwd.vue?vue&type=template&id=2b02e7c6&scoped=true&"
import script from "./ChangePwd.vue?vue&type=script&lang=ts&"
export * from "./ChangePwd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b02e7c6",
  null
  
)

export default component.exports